import * as t from 'io-ts';

import type { CheckBoxDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';

export interface ShortLabelsSettingDefinition extends CheckBoxDefinition {
    key: 'SHORT_LABELS';
}

const definition: ShortLabelsSettingDefinition = {
    key: 'SHORT_LABELS',
    type: 'CheckBox',
    label: 'Use short labels',
    value: false,
    scope: 'user',
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.boolean);

export const codec = specSettingsInterface.input;

export const ShortLabelsSettingDefinition = define({
    key: 'SHORT_LABELS',
    label: 'ShortLabels',
    definition,
    fromSetting: settings => specSettingsInterface.extractValue(settings.shortLabels),
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        specSettingsInterface.createDefinitionWithSettings(settings.shortLabels),
});
